import { getDataIngestionData } from '@/services/dataIngestionHistory';
export const fetchDataIngestionTodayAlerts = ({ limit, page }) => getDataIngestionData({
    limit,
    page,
    home: 1,
}).then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    const today = new Date().toISOString().split('T')[0];
    return {
        todayAlerts: response?.data[today]?.alerts || [],
    };
};
